@for (componentWidget of componentWidgets(); track componentWidget.uniqueId) {
  <tt-component-widget
    [allowEditTags]="allowEditTags()"
    [expandStrategy]="widget().componentExpandStrategyOnRead"
    [widget]="componentWidget" />
}
